import Worker from 'web-worker';
export function createWorker(relativePath, base) {
    // Convert the relative path to an absolute path
    const absolutePath = new URL(relativePath, base).href;
    return new Worker(absolutePath, {
        // Load the worker as an ES module
        type: 'module',
    });
}
